import React, { useState, useEffect } from 'react';
import axios from 'axios'
import Offcanvas from '../../../components/common/Offcanvas';
import { useSelector } from 'react-redux'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

const MobileMenu = ({ match }) => {
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

    const menuName = match.params.id;

    const [menu,setMenu] = useState([])
    const [menuId,setMenuId] = useState('')
    const [items, setItems] = useState([])

    // for editing
    const [changes, setChanges] = useState(false);
    const [menuDataToEdit, setMenuDataToEdit] = useState(null);

    const editHandler = (menu) => {
      setMenuDataToEdit(menu);
    };

    const addOrUpdatePrimaryMenu = async (primaryMenu) => {
      try {

        const formData = new FormData();
        formData.append('menuName', primaryMenu.menuName);
        formData.append('menuURL', primaryMenu.menuURL);

        if (primaryMenu._id) {
          formData.append('submenuId', primaryMenu._id);
        }

        if (primaryMenu.featuredImage && primaryMenu.featuredImage instanceof File) {
          formData.append('featuredImage', primaryMenu.featuredImage);
        } else if (primaryMenu.featuredImage && typeof primaryMenu.featuredImage === 'string') {
          formData.append('existingFeaturedImage', primaryMenu.featuredImage);
        }

        if (primaryMenu._id) {
          await axios.put(`${process.env.REACT_APP_API_URL}/api/mobile-menu/submenu/${menuId}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        } else {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/mobile-menu/menu/${menuId}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }

        fetchMenuData();
        setMenuDataToEdit(null);
        setChanges(false);

      } catch (error) {
        console.error('Error adding or updating the menu:', error);
      }
    };

    const fetchMenuData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/mobile-menu/${menuName}`);
        setMenu(response.data);
        setMenuId(response.data._id)
        setItems(response.data?.menuList || [])
      } catch (error) {
        console.error('Error fetching menu data:', error);
      }
    };

    const deleteHandler = async (submenuId) => {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
        data: {
          submenuId,
        },
      };

      if (window.confirm('Are you sure you want to delete this submenu?')) {
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/api/mobile-menu/submenu/${menuId}`, config);
          fetchMenuData();
          alert('Submenu deleted successfully');
        } catch (error) {
          console.error('Error deleting submenu:', error);
          alert('Error deleting submenu');
        }
      }
    };

    const onDragEnd = async (result) => {
      if (!result.destination) return
      if (result.destination.index === result.source.index) return

      const reordered = Array.from(items)
      const [moved] = reordered.splice(result.source.index, 1)
      reordered.splice(result.destination.index, 0, moved)
      setItems(reordered)

      try {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/mobile-menu/reorder/${menuId}`,
          { orderedIds: reordered.map((it) => it._id) },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        )
      } catch (error) {
        console.error('Error reordering menu:', error)
        // revert on failure
        fetchMenuData()
      }
    }

    useEffect(() => {
      fetchMenuData();
    }, []);

    return (
        <>

        <section className='product-admin'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='card mb-3'>
                            <div className='card-header'>Menu items</div>
                                <ul className='list-group'>
                                    <DragDropContext onDragEnd={onDragEnd}>
                                      <Droppable droppableId='mobileMenuList'>
                                        {(provided) => (
                                          <div {...provided.droppableProps} ref={provided.innerRef}>
                                            {items.map((item, index) => (
                                              <Draggable key={item._id} draggableId={String(item._id)} index={index}>
                                                {(prov, snapshot) => (
                                                  <li
                                                    ref={prov.innerRef}
                                                    {...prov.draggableProps}
                                                    className='list-group-item d-flex justify-content-between align-items-center'
                                                    style={{
                                                      ...prov.draggableProps.style,
                                                      backgroundColor: snapshot.isDragging ? '#f0f7ff' : '#fff',
                                                    }}
                                                  >
                                                    <div className='d-flex align-items-center'>
                                                      <span
                                                        {...prov.dragHandleProps}
                                                        style={{ cursor: 'grab', padding: '0 12px 0 0', color: '#999', fontSize: '18px' }}
                                                        title='Drag to reorder'
                                                      >
                                                        ⠿
                                                      </span>
                                                      <span>{item.menuName}</span>
                                                    </div>
                                                    <div>
                                                      <button className='btn btn-warning btn-sm me-3' onClick={() => {
                                                        editHandler(item);
                                                      }} data-bs-toggle='offcanvas' href='#primaryMenuSidebar'>Edit</button>
                                                      <button className='btn btn-danger btn-sm'
                                                      onClick={() => deleteHandler(item._id)}
                                                      >Delete</button>
                                                    </div>
                                                  </li>
                                                )}
                                              </Draggable>
                                            ))}
                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>
                                    </DragDropContext>

                                <a className='d-block' data-bs-toggle='offcanvas' role='button'
                                    href='#primaryMenuSidebar' aria-controls='primaryMenuSidebar'
                                    onClick={() => setMenuDataToEdit(null)}>
                                    <li className='list-group-item d-flex editMenu bg-success text-light justify-content-center'>
                                      Add New
                                    </li>
                                </a>

                                </ul>
                            </div>
                    </div>
                </div>
            </div>
        </section>

        <Offcanvas
            setChanges={setChanges}
            id="primaryMenuSidebar"
            canvasLabel="Edit Primary Menu"
            onAdd={addOrUpdatePrimaryMenu}
            menuDataToEdit={menuDataToEdit}
        />

        </>
    );
}

export default MobileMenu
